import * as b_ from "b_"

export const bem = b_.B({
    tailSpace: " ",
    elementSeparator: "__",
    modSeparator: "--",
    modValueSeparator: "__",
    classSeparator: " ",
})

export default bem
